/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';

import MarketoForm from 'molecules/Form';

import type { SignUpIdentity } from 'components/FreeTrialFTUX/config/types';

interface SignUpStepProps {
  formData?: FormReference;
  heading: string;
  subheading: string;
  onSuccess: (identity: SignUpIdentity) => void;
  isTransitioning: boolean;
}

const normalizeIdentity = (values: Record<string, any>): SignUpIdentity => ({
  firstName: values.FirstName || values.firstName || '',
  lastName: values.LastName || values.lastName || '',
  email: values.Email || values.email || '',
  company: values.Company || values.company || '',
  role: values.Role__c || values.Role || values.role || '',
});

const SignUpStep: FC<SignUpStepProps> = ({ formData, heading, subheading, onSuccess, isTransitioning }) => {
  const handleSubmitSuccess = (ctx?: { values?: Record<string, any> }) => {
    const identity = normalizeIdentity(ctx?.values || {});
    if (identity.email) {
      onSuccess(identity);
    }

    return false;
  };

  return (
    <div
      className={`flex flex-col gap-5 p-6 transition-all duration-300 ease-out md:min-h-[28rem] md:flex-row md:gap-0 md:p-0 ${
        isTransitioning ? 'translate-y-1 opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="flex flex-col gap-3 md:w-64 md:shrink-0 md:gap-5 md:py-12 md:pl-9 md:pr-6">
        <h2 className="font-roboto text-3xl font-medium leading-9 text-gray-900 md:text-4xl md:leading-10">
          {heading}
        </h2>
        <p className="font-roboto text-md font-medium leading-6 text-gray-1000 md:text-xl md:leading-8">{subheading}</p>
      </div>

      <div className="hidden w-px self-stretch bg-gray-300 md:block" />

      <div className="marketo-form--flat flex min-w-0 flex-1 flex-col md:px-9 md:py-12">
        {formData && (
          <MarketoForm
            formData={formData}
            callback={handleSubmitSuccess}
            extraHiddenFields={{ Lead_Type__c: 'free_trial_group_creator' }}
          />
        )}
      </div>
    </div>
  );
};

export default SignUpStep;
